import { Outlet } from 'react-router'
import { SiteFooter } from '../components/footer'
import { SiteHeader } from '../components/header'

const Page = () => {
  return (
    <div className="flex flex-col min-h-dvh">
      <SiteHeader />
      <Outlet />
      <SiteFooter />
    </div>
  )
}

export default Page
